<div class="task-details" fill fill-padding="25" *ngIf="state.windowsTaskThreads && state.windowsTaskThreads.length > 0">
    <div class="back" (click)="goBack()">
            <a>
                <span class="hd-icon icon-sm hd-icon-arrow"></span>
                <span class="selectedTask-name">{{state.selectedTask.name}}</span>
            </a>
    </div>

    <div class="task-details-thread task-details-flextable-container" [ngClass]="(state.windowsTaskModules.length > 0) ? 'regularHeight' : 'maxHeight'">
        <div class="task-details-title">
            <div>
                <div class="task-details-table-title">{{'taskWindowsDetails_threads' | xsI18n }}</div>
            </div>
            <div>
                <div class="task-details-flextable-row">
                    <div class="task-details-flextable-cell heading-cell cell-left" (click)="sortThreadTableBy('threadId')">
                        {{'taskWindowsDetails_threadId' | xsI18n }}
                            <span *ngIf="threadTableSortInfo.column === 'threadId'" class="hd-icon icon-sm" [ngClass]="threadTableSortInfo.reverse?'hd-icon-sortdown':'hd-icon-sortup'"> </span>
                    </div>
                    <div class="task-details-flextable-cell heading-cell cell-right fill" (click)="sortThreadTableBy('priority')">
                        {{'taskWindowsDetails_priority' | xsI18n }}
                        <span *ngIf="threadTableSortInfo.column === 'priority'" class="hd-icon icon-sm" [ngClass]="threadTableSortInfo.reverse?'hd-icon-sortdown':'hd-icon-sortup'"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="task-details-flextable scroll threadScrollArea">
            <div class="task-details-flextable-row bottom-border" *ngFor="let thread of state.windowsTaskThreads">
                <div class="task-details-flextable-cell hex-font cell-left" hd-ellipsis-text>{{thread.threadId}}</div>
                <div class="task-details-flextable-cell hex-font cell-right fill" hd-ellipsis-text>{{thread.priority}}</div>
            </div>
        </div>
    </div>
<div class="task-details-flextable-container maxHeight" [class.hide]="state.windowsTaskModules.length <= 0">
    <div class="task-details-title">
        <div>
            <div class="task-details-table-title">{{'taskWindowsDetails_modules' | xsI18n }}</div>
        </div>
        <div>
            <div class="task-details-flextable-row">
                <div class="task-details-flextable-cell heading-cell cell-left" (click)="sortModuleTableBy('name')">
                    {{'xs_name_label' | xsI18n }}
                        <span *ngIf="moduleTableSortInfo.column === 'name'" class="hd-icon icon-sm" [ngClass]="moduleTableSortInfo.reverse?'hd-icon-sortdown':'hd-icon-sortup'"></span>
                </div>
                <div class="task-details-flextable-cell heading-cell cell-right fill" (click)="sortModuleTableBy('baseAddress')">
                {{'taskWindowsDetails_baseAddr' | xsI18n }}
                    <span *ngIf="moduleTableSortInfo.column === 'baseAddress'" class="hd-icon icon-sm" [ngClass]="moduleTableSortInfo.reverse?'hd-icon-sortdown':'hd-icon-sortup'"></span>
                </div>
                <div class="task-details-flextable-cell heading-cell cell-right base-size-cell fill" (click)="sortModuleTableBy('baseSize')">
                {{'taskWindowsDetails_baseSize' | xsI18n }}
                    <span *ngIf="moduleTableSortInfo.column === 'baseSize'" class="hd-icon icon-sm" [ngClass]="moduleTableSortInfo.reverse?'hd-icon-sortdown':'hd-icon-sortup'"></span>
                </div>
                <div class="task-details-flextable-cell heading-cell cell-right fill" (click)="sortModuleTableBy('usage')">
                {{'taskWindowsDetails_usage' | xsI18n }}
                    <span *ngIf="moduleTableSortInfo.column === 'usage'" class="hd-icon icon-sm" [ngClass]="moduleTableSortInfo.reverse?'hd-icon-sortdown':'hd-icon-sortup'"></span>
                </div>
                <div class="task-details-flextable-cell heading-cell cell-right fill" (click)="sortModuleTableBy('procUsage')">
                {{'taskWindowsDetails_procUsage' | xsI18n }}
                    <span *ngIf="moduleTableSortInfo.column === 'procUsage'" class="hd-icon icon-sm" [ngClass]="moduleTableSortInfo.reverse?'hd-icon-sortdown':'hd-icon-sortup'"></span>
                </div>
                <div class="task-details-flextable-cell heading-cell cell-right fill" (click)="sortModuleTableBy('handle')">
                {{'taskWindowsDetails_handle' | xsI18n }}
                    <span *ngIf="moduleTableSortInfo.column === 'handle'" class="hd-icon icon-sm" [ngClass]="moduleTableSortInfo.reverse?'hd-icon-sortdown':'hd-icon-sortup'"></span>
                </div>
            </div>
        </div>
    </div>
    <div class="task-details-flextable scroll threadScrollArea">
        <div class="task-details-flextable-row bottom-border" *ngFor="let module of state.windowsTaskModules">
            <div class="task-details-flextable-cell cell-left" hd-ellipsis-text>{{module.name}}</div>
            <div class="task-details-flextable-cell cell-right hex-font fill" hd-ellipsis-text>{{module.baseAddress}}</div>
            <div class="task-details-flextable-cell cell-right base-size-cell hex-font fill" hd-ellipsis-text>{{module.baseSize}}</div>
            <div class="task-details-flextable-cell cell-right hex-font fill" hd-ellipsis-text>{{module.usage}}</div>
            <div class="task-details-flextable-cell cell-right hex-font fill" hd-ellipsis-text>{{module.procUsage}}</div>
            <div class="task-details-flextable-cell cell-right hex-font fill" hd-ellipsis-text>{{module.handle}}</div>
        </div>
    </div>
</div>
<div class="detailNotAvailable" *ngIf="state.windowsTaskThreads && state.windowsTaskThreads.length <= 0" fill>
    <img class="NotFound" src="'get-resource/images/NotFound.svg'"/>
    <div>{{'taskDetails_unavailable' | xsI18n }}</div>
    <hr class="hr">
    <div class = "back-btn btn-lg" (click)="goBack()">
        <a>
            <span class="hd-icon icon-md hd-icon-chevron-left"></span>{{'taskDetails_back' | xsI18n }}
        </a>
    </div>
</div>